//JW Player Constants
export const playerScript = "https://cdn.jwplayer.com/libraries/4ZJKHLed.js";
export const playerId = "jw-player-id";
